<template>
  <v-chart :option="chartOption" autoresize />
</template>

<script>
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent
} from 'echarts/components'
import VChart from 'vue-echarts'

use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  GridComponent
])

export default {
  name: 'OutboundChart',
  components: {
    VChart
  },
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartOption() {
      return {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.data.map(item => item.date),
          boundaryGap: false
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '出库数量',
            type: 'line',
            data: this.data.map(item => item.count),
            areaStyle: {
              opacity: 0.1
            },
            lineStyle: {
              width: 3
            },
            itemStyle: {
              color: '#409EFF'
            },
            smooth: true
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 300px;
}
</style> 